import { TProduct } from "../components";

export const DEMO_VIDEO_URL = "assets/video/nike_we_fly.mp4";
export const DEMO_PRODUCT_URL = "assets/images/pdp-page/product-pic1.jpg";

export const mockProduct: TProduct = {
  colors: [
    {
      id: "1",
      name: "color",
      value: "green",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic1.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic1.jpg",
        },
      },
      category: "men",
    },
    {
      id: "2",
      name: "color",
      value: "blue",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic2.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic2.jpg",
        },
      },
      status: "unavailable",
      category: "women",
    },
    {
      id: "3",
      name: "color",
      value: "cyan",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic3.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic3.jpg",
        },
      },
      category: "men",
    },
    {
      id: "4",
      name: "color",
      value: "red",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic4.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic4.jpg",
        },
      },
      status: "unavailable",
      category: "men",
    },
    {
      id: "5",
      name: "color",
      value: "white",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic5.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic5.jpg",
        },
      },
      category: "men",
    },
    {
      id: "6",
      name: "color",
      value: "black",
      image: {
        data: {
          src: "assets/images/pdp-page/product-pic6.jpg",
          alt: "",
        },
        thumbnail: {
          src: "assets/images/pdp-page/product-pic6.jpg",
        },
      },
      category: "men",
    },
  ],
  sizes: [],
};
